import { FiMoreVertical } from "react-icons/fi";

// Status indicator with icon and timer component
const PastDateEntryStatus = ({ remainingTime, formatTime }) => {
  // Only render when past date entry is active
  // Horizontally aligned past date entry status component using only inline styling
  // Only render the more icon when past date entry is inactive
  if (remainingTime === 0) {
    return <FiMoreVertical size={18} />;
  }

  // Return horizontally aligned timer and more icon when active
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      {/* Timer pill */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "12px",
          padding: "2px 8px",
          backgroundColor: "#fffbeb",
          border: "1px solid #fde68a",
          borderRadius: "4px",
          color: "#277a2e",
        //   color: "#b45309",
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: "4px" }}
        >
          <path
            d="M12 6V12L16 14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
        <span
          style={{
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          {formatTime(remainingTime)}
        </span>
      </div>

      {/* More actions icon */}
      <FiMoreVertical size={18} style={{ color: "#4b5563" }} />
    </div>
  );
};

export default PastDateEntryStatus;
